export const infoOptions = [
  {
    label: "Pending ",
    color: "#E9A30C",
    value: "pending"
  },
  {
    label: "Completed",
    color: "#3F9142",
    value: "completed"
  }
];

export const instagramStatusOptions = [
  {
    label: "All",
    value: "all"
  },
  {
    label: "Does not meet criteria",
    value: "does_not_meet_criteria"
  },
  {
    label: "Verified",
    value: "verified"
  },
  {
    label: "Private Profile",
    value: "private_profile"
  }
];

export const searchFieldOptions = [
  { label: "Creator User Name", value: "name" },
  { label: "Instagram Handle", value: "instagram_handle" },
  { label: "Phone Number", value: "phone_number" }
];
